import { useEffect, useState } from 'react';
import { getCustomFields } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export const useCaseDetailsCustomField = (loadFullList = true, limit = 5, isLandingPage = false, module = '') => {
  const [customFields, setCustomFields] = useState([]);
  const [caseCustomFieldList, setCaseCustomFieldList] = useState([]);
  const [contactCustomFieldList, setContactCustomFieldList] = useState([]);
  const [companyCustomFieldList, setCompanyCustomFieldList] = useState([]);
  const [nextToken, setNextToken] = useState(null);

  const loadCustomFields = async (module = '', nextToken = '') => {
    try {
      let pageLimit = limit;
      if (loadFullList) {
        const response = await totalCountEvent('custom-field');
        pageLimit = response?.data;
      }
      const res = await getCustomFields(module, pageLimit, nextToken);
      setCustomFields(res?.data?.['custom-field']);
      setNextToken(res?.data?.['next_token']);
      return res?.data?.['custom-field'];
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadCustomFields(module);
  }, []);

  useEffect(() => {
    if (customFields.length > 0) {
      setCaseCustomFieldList(customFields.filter((v) => v.module === 'case'));
      setContactCustomFieldList(customFields.filter((v) => v.module === 'contact'));
      setCompanyCustomFieldList(customFields.filter((v) => v.module === 'companies'));
    }
  }, [customFields]);
  return { caseCustomFieldList, contactCustomFieldList, companyCustomFieldList, loadCustomFields, nextToken };
};
